<template>
	<div class="solution">		
		<div class="head" :style="{backgroundImage: 'url(' + img.headBg + ')'}">
			<div class="content">
				<h3>同品牌公司一样，享有最专业的私有云解决方案</h3>
				<p>账号与权限管理是身份认证和访问权限控制的服务；适用于同一组织下多成员共同管理云计算资源及财务信息的场景；可授予不同成员于不同的资源操作权限。利于企业规划管理及成员权限</p>
				<el-button @click="fnToRouter('/404')">开启私有云</el-button>
			</div>
		</div>
		<div id="tabs" class="tabs">
			<el-tabs :class="{fixed:isFixed}" v-model="tab_active" @tab-click="tabClick">
				<el-tab-pane name="2_1" label="热门方案">
				</el-tab-pane>
				<el-tab-pane name="2_2" label="行内方案">
				</el-tab-pane>
				<el-tab-pane name="2_3" label="受益客户">
				</el-tab-pane>
			</el-tabs>
			<div class="text">
				<h3 class="tab1"><i class="el-icon-caret-right"></i>热门解决方案</h3>
				<div class="tab">
					<tab_1></tab_1>
				</div>
				<h3 class="tab2"><i class="el-icon-caret-right"></i>行内解决方案</h3>
				<div class="tab">
					<div>我们以用户的需求主导产品研发，提供丰富、高性能、稳定的产品和服务</div>
					<tab_2></tab_2>
				</div>
				<h3 class="tab3"><i class="el-icon-caret-right"></i>受益客户</h3>
				<div class="tab">
					<tab_3></tab_3>
				</div>
			</div>
		</div>
		<foot></foot>
	</div>
</template>

<script>
	import tab_1 from '@/modules/solution/tab_1.vue'
	import tab_2 from '@/modules/solution/tab_2.vue'
	import tab_3 from '@/modules/solution/tab_3.vue'
	import foot from '@/modules/home/page_6.vue'
	export default {
		name: 'solution',
		data() {
			return {
				"img":{
					headBg:require("@/assets/img/solution/title_img.png")
				},
				"tab_active":"2_1",
				"isFixed":false,
				"y":{
					"scroll":0,
					"tabs":0,
					"tab":[],
					"foot":0
				}
			}
		},
		//计算数据
		computed: {
		},
		//参数数据
		props: {},
		//方法
		methods: {
			bodyScroll(){			
			    this.y.scroll = window.pageYOffset
			    	|| document.documentElement.scrollTop  
		            || document.body.scrollTop  
		            || 0;
		        this.isFixed = this.y.scroll >= this.y.tabs;
		        if(this.y.scroll > this.y.foot - 60){
		        	this.isFixed = false;
		        }		        
		        if(this.y.scroll >= this.y.tab["2_1"]){
		        	this.tab_active = "2_1"
		        }
		        if(this.y.scroll >= this.y.tab["2_2"]){
		        	this.tab_active = "2_2"
		        }
		        if(this.y.scroll >= this.y.tab["2_3"]){
		        	this.tab_active = "2_3"
		        }
		        
			},
			tabClick(i, o) {
				console.log(i.name);
				console.log(this.y.tab[i.name]);
				window.scrollTo(0, this.y.tab[i.name]);
			}
		},
		//组件
		components: {
			tab_1,			
			tab_2,			
			tab_3,
			foot
		},
		//生命周期-创建
		created() {
			
		},
		//生命周期-准备就绪
		mounted() {
			this.y.tabs = document.getElementsByClassName("tabs")[0].offsetTop;
			this.y.tab["2_1"] = document.getElementsByClassName("tab1")[0].offsetTop-100;
			this.y.tab["2_2"] = document.getElementsByClassName("tab2")[0].offsetTop-100;
			this.y.tab["2_3"] = document.getElementsByClassName("tab3")[0].offsetTop-100;
			this.y.foot = document.getElementsByClassName("page_6")[0].offsetTop;
			if(window.attachEvent){
			    window.attachEvent('onscroll',this.bodyScroll);
			}else if(document.addEventListener) {
				document.addEventListener('scroll', this.bodyScroll, false);
			}
		},
		//监控变量
		watch: {}
	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
	@import url("../assets/common.less");
	.solution {
		& > .head{
			background-size:100%;
			width:100%;
			min-width:1080px;
			height:350px;
			position:relative;
			color:#FFF;
			& > .content{
				padding:130px 0;
				width:1080px;
				margin:0 auto;
				& > h3{
					.h4();
				}
				& > p{
					width: 60%; text-indent: 2em;
				}
				& > .el-button{
					background-color: inherit;
					color: #FFF;
					margin:50px;
					padding: 15px;
					width: 200px;
					border-color: #bfcbd9;
				}
			}
		}
		.tabs{
			padding: 10px 0;
			width: 1080px;
			margin: 0 auto;
			.el-tabs{
				position: absolute;
				background-color: #FFFFFF;
				z-index: 999;
				width: 1080px;
				&.fixed{
					position: fixed;
					top: 0;
				}
				.tab_head{
					text-align: center;
					width: 150px;
					font-size: 18px;
					&:hover{
						color: @theme-color;
					}
				}
			}
			& > .text{
				margin-top: 60px;
				.tab{
					overflow: hidden;
					margin: 30px;
				}
				& > h3{
					&>i{
						color: @theme-color;
						padding-right: 10px;
					}
				}
			}
		}
	}
</style>


// WEBPACK FOOTER //
// Solution.vue?10d3fd10